//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCodCuentas } from "@/typings/store/plugins/easyFirestore/codCuentas";

const getters: GetterTree<StateCodCuentas, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const codCuentas = {
    firestorePath: "dev/v1/codCuentas",
    firestoreRefType: "collection",
    moduleName: "codCuentas",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default codCuentas;
